import {CommonModule} from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button'; // Import MatButtonModule
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-image-modal',
	templateUrl: './image-modal.component.html',
	styleUrl: './image-modal.component.scss',

	imports: [
		CommonModule,
		MatDialogContent,
		MatDialogActions,
		MatIconModule
	],
})
export class ImageModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string }
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
